import React, { useEffect, useState } from 'react'
import SignUpDistribution from './SignUpDistribution'
import UserTypeBreakdown from './UserTypeBreakdown'
import { useSelector } from 'react-redux';
import { fetchSignUpDistribution } from '../../../api/nystats';
import { Stack } from '@mui/material';

export default function CommonUserDistribution() {
   const { filter } = useSelector((state) => state);
   const [platform,setPlatform] = useState([])
   const [userTypes,setUserTypes] = useState(null)
  const [isLoading, setIsLoading] = useState(true);
	useEffect(() => {
		const load = async () => {
			try {
				setIsLoading(true)
				const { userTypes, platform } = await fetchSignUpDistribution(filter);
				setUserTypes(userTypes ?? [])
				setPlatform(platform ?? [])
			} catch (e) {
				console.error("Error loading user type breakdown", e);
			}
			setIsLoading(false)
		};
		load();
	}, [JSON.stringify(filter)]);
    return (
        <Stack spacing={2}>
            <SignUpDistribution platform={platform} isLoading={isLoading}/>
            <UserTypeBreakdown userTypes={userTypes} isLoading={isLoading}/>
        </Stack>
    )
}
